import { Button, Cascader, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { CHANNEL, COMMUNICATE_MODULE, INTENTION } from "@zhihaoscm/meta";
import { customerService } from "@/api/services/customerService";
import { areaLib } from "@/utils/areaLib";
import { useAreaLib } from "@/utils/hooks/useAreaLib";
import UserLabel from "./userLabel";

/** 用户沟通画像编辑表单，复用 customerService.updateCustomerInfo 字段契约。 */
export default function UserInfoForm({
    info,
    userId,
    onCancel,
    onSaved
}: {
    info?: Record<string, any>;
    userId?: number;
    onCancel?: () => void;
    onSaved?: () => void;
}) {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const areaLibrary = useAreaLib();
    const areaOptions = areaLibrary.areaList2Options(
        areaLibrary.areaData.map(province => ({
            ...province,
            // 旧 Vue 编辑页只允许省市两级，保持级联面板宽度和提交字段契约。
            childs: province.childs?.map(city => ({ id: city.id, name: city.name, shortName: city.shortName }))
        }))
    );
    useEffect(() => {
        form.setFieldsValue({
            ...info,
            regionCode: [info?.provinceCode, info?.cityCode].filter(Boolean),
            userLabel: info?.userLabel || []
        });
    }, [info, form]);
    const submit = async (values: any) => {
        if (!userId) return;
        setSaving(true);
        try {
            const regionCode = Array.isArray(values.regionCode) ? values.regionCode : [];
            const provinceCode = regionCode[0] || values.provinceCode;
            const cityCode = regionCode[1] || values.cityCode;
            // Vue 旧表单同时提交编码和名称，保存后详情页才能稳定回显区域而不是 `--`。
            await customerService.updateCustomerInfo(userId, {
                ...values,
                provinceCode,
                cityCode,
                provinceName: areaLib.getAreaName(provinceCode) || values.provinceName,
                cityName: areaLib.getAreaName(cityCode, { provinceAdcode: provinceCode }) || values.cityName
            });
            onSaved?.();
        } finally {
            setSaving(false);
        }
    };
    return (
        <div className="customer-user-info-form">
            <span className="sr-only">编辑用户信息</span>
            <Form form={form} layout="horizontal" onFinish={values => void submit(values)}>
                <div className="customer-user-info-form__grid">
                    <Form.Item name="name" label="姓名">
                        <Input maxLength={15} />
                    </Form.Item>
                    <Form.Item label="区域" name="regionCode">
                        <Cascader
                            allowClear
                            aria-label="区域"
                            options={areaOptions}
                            placeholder="请选择区域"
                            showSearch
                        />
                    </Form.Item>
                    <Form.Item name="channel" label="了解渠道">
                        <Select options={CHANNEL.options} />
                    </Form.Item>
                    <Form.Item name="intention" label="意向度">
                        <Select options={INTENTION.options} />
                    </Form.Item>
                    <Form.Item name="sandFlag" label="是否为砂石行业">
                        <Select
                            options={[
                                { value: 1, label: "是" },
                                { value: 0, label: "否" }
                            ]}
                        />
                    </Form.Item>
                    <Form.Item name="industry" label="行业">
                        <Input maxLength={15} />
                    </Form.Item>
                    <Form.Item name="settlePlatformFlag" label="是否需要入驻平台">
                        <Select
                            options={[
                                { value: 1, label: "是" },
                                { value: 0, label: "否" }
                            ]}
                        />
                    </Form.Item>
                    <Form.Item name="concernModule" label="关注模块">
                        <Select maxTagCount={1} mode="multiple" options={COMMUNICATE_MODULE.options} />
                    </Form.Item>
                </div>
                <Form.Item name="userLabel" label="用户标签">
                    <UserLabel info={info?.userLabel} onChange={value => form.setFieldValue("userLabel", value)} />
                </Form.Item>
                <Space>
                    <Button type="primary" htmlType="submit" loading={saving}>
                        保存
                    </Button>
                    <Button onClick={onCancel}>取消</Button>
                </Space>
            </Form>
        </div>
    );
}
